import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

export async function createPackage(packageObj) {
  try {
    const encodedData = btoa(JSON.stringify(packageObj));
    const fd = new FormData();
    fd.append("package_data", encodedData);

    const response = await axios.post(`${apiBaseUrl}package/create_pkg`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("createPackage error:", error);
    return { status: false, type: "danger", success: "Failed to save package" };
  }
}

// 🔹 Get Package List
export async function getPackages(package_by, page_no = "0", package_status = "", search_key = "") {
  try {
    const fd = new FormData();
    fd.append("package_by", package_by);
    fd.append("page_no", page_no);
    fd.append("package_status", package_status);
    fd.append("search_key", search_key);

    const response = await axios.post(`${apiBaseUrl}package/get_pkgs`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("getPackages error:", error);
    return { status: false, type: "danger", success: "Failed to load packages" };
  }
}

// 🔹 Get Package Report
export async function getPackageReport(package_by) {
  try {
    const fd = new FormData();
    fd.append("package_by", package_by);

    const response = await axios.post(`${apiBaseUrl}package/get_pkg_report`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("getPackageReport error:", error);
    return { status: false, type: "danger", success: "Failed to load package report" };
  }
}

// 🔹 Delete Package
export async function deletePackage(package_id) {
  try {
    const fd = new FormData();
    fd.append("package_id", package_id);

    const response = await axios.post(`${apiBaseUrl}package/delete_pkg`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("deletePackage error:", error);
    return { status: false, type: "danger", success: "Failed to delete package" };
  }
}

// 🔹 Update Package Status
export async function updatePackageStatus(package_id, package_status) {
  try {
    const fd = new FormData();
    fd.append("package_id", package_id);
    fd.append("package_status", package_status);

    const response = await axios.post(`${apiBaseUrl}package/update_pkg_status`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("updatePackageStatus error:", error);
    return { status: false, type: "danger", success: "Failed to update package status" };
  }
}
